module.exports = __webpack_public_path__ + "static/img/o4.c321615.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/o4.jpg
// module id = tOVp
// module chunks = 0